<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <Box theme="box-primary">
        <div slot="content">
          <b-tabs content-class="mt-3" @change="handleTabChange">
            <b-tab title="Danh sách SĐT đang kiểm tra" active>
              <div class="col-md-12 col-sm-12 col-xs-12">
                <Box theme="box-primary" title="Tìm kiếm">
                  <div slot="content">
                    <div v-show="isShowSearch('pickup_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
                      <label>Ngày lấy</label>
                      <date-picker v-model="filterData.pickup_date" range valueType="format"></date-picker>
                    </div>
                    <div v-show="isShowSearch('phone_number')" class="form-group col-md-3 col-sm-6 col-xs-12">
                      <label>Số thành viên</label>
                      <input type="text" class="form-control" v-model="filterData.phone_number" v-on:keyup.enter="search"
                             placeholder="Nhập tên số thành viên..."/>
                    </div>
                    <div v-show="isShowSearch('phone_status')" class="form-group col-md-3 col-sm-6 col-xs-12">
                      <label>Trạng thái số</label>
                      <multiselect v-model="filterData.phone_status" :options="technicalStatusList" :multiple="true"
                                   :close-on-select="false"
                                   placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
                    </div>
                  </div>
                  <div slot="footer">
                    <div class="d-flex justify-content-end align-items-center">
                      <b-button v-if="!this.isTechnicalStaff" variant="danger" @click="addPhoneNumber" class="mr-2" :disabled="!isEditable"
                                style="margin-top: 25px"><span
                        class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                        Thêm mới
                      </b-button>
                      <b-button variant="primary" @click="bulkUpdateSelectedStatus" class="mr-2" :disabled="!isEditable"
                                style="margin-top: 25px"><span
                        class="fa fa-exchange" aria-hidden="true"></span>
                        Chuyển trạng thái lựa chọn
                      </b-button>
                      <b-button variant="warning" @click="bulkUpdateStatus" class="mr-2" :disabled="!isEditable"
                                style="margin-top: 25px"><span
                        class="fa fa-exchange" aria-hidden="true"></span>
                        Chuyển trạng thái tất cả
                      </b-button>
                      <b-button variant="info" @click="exportPhoneNumber" class="mr-2" style="margin-top: 25px"
                                :disabled="!isEditable"><span
                        class="glyphicon glyphicon-export" aria-hidden="true"></span>
                        Export
                      </b-button>
                      <b-button variant="secondary" @click="copyAllPhoneNumber" class="mr-2" style="margin-top: 25px">
                        <span class="glyphicon glyphicon-copy" aria-hidden="true"></span>
                        Copy SĐT lựa chọn
                      </b-button>
                      <b-button variant="success" @click="search" style="margin-top: 25px">
                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
                      </b-button>
                    </div>
                  </div>
                </Box>
              </div>

              <div class="col-md-12 col-sm-12 col-xs-12">
                <Box theme="box-primary" title="Danh sách số điện thoại">
                  <div slot="custombtn">
                    <button id="popover-config-table" class="btn btn-box-tool">
                      <i class="fa fa-cog" aria-hidden="true"></i>
                    </button>
                    <b-popover :show.sync="showConfigTable" target="popover-config-table" title="Cấu hình hiển thị"
                               triggers="hover">
                      <b-table :items="configItems" responsive :fields="configFields">
                        <template v-slot:cell(key)="data">
                          <b-form-checkbox v-model="data.item.show"
                                           @change="toggleColumn($event, data.item.key)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(label)="data">
                          {{ data.item.label }}
                        </template>
                      </b-table>
                    </b-popover>
                  </div>
                  <div slot="content">
                    <b-table bordered outlined hover responsive
                             :busy="loading"
                             :fields="fields"
                             :items="checkingItems"
                             show-empty
                             :select-mode="'multi'"
                             ref="selectableTable"
                             @row-dblclicked="onDoubleClicked"
                             selectable
                             @row-selected="onRowSelected"
                    >

                      <template #table-busy>
                        <div class="text-center my-2 mt-5 mb-5">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Đang tải...</strong>
                        </div>
                      </template>

                      <template #empty="scope">
                        <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
                      </template>
                      <template #head(row_selected)="data">
                        <b-form-checkbox
                          id="checkbox-1"
                          v-model="checkAll"
                          @change="onCheckAll"
                          name="checkbox-1"
                          value="check_all"
                          unchecked-value="uncheck_all"
                        >
                        </b-form-checkbox>
                      </template>

                      <template v-slot:cell(row_selected)="data">
                        <div class="d-flex justify-content-center flex-column align-items-center">
                          <b-form-group>
                            <b-form-checkbox type="checkbox" v-model="data.rowSelected"
                                             @change="toggleRow(data)"></b-form-checkbox>
                          </b-form-group>
                        </div>
                      </template>
                      <template v-slot:cell(phone_number)="data">
                        <span @click="onClickPhoneNumber(data.item.phone_number)">{{data.item.phone_number}}</span>
                      </template>
                      <template v-slot:cell(main_phone_number)="data">
                        <ColorTags v-if="data.item.main_phone_number" :tags="generateTag(buildMainPhoneNumber(data.item.main_phone_number))" :size="'md'"></ColorTags>
                      </template>
                      <template v-slot:cell(provider)="data">
                        <ColorTags v-if="data.item.provider" :tags="generateTag(buildProvider(data.item.provider))" :size="'md'"></ColorTags>
                      </template>
                      <template v-slot:cell(legal)="data">
                        <ColorTags v-if="data.item.legal" :tags="generateTag(buildLegal(data.item.legal))" :size="'md'"></ColorTags>
                      </template>
                      <template v-slot:cell(phone_number_client)="data">
                        <ColorTags v-if="data.item.phone_number_client" :tags="generateTag(buildPhoneClient(data.item.phone_number_client))" :size="'md'"></ColorTags>
                      </template>
                      <template v-slot:cell(phone_number_status)="data">
                        <ColorTags v-if="data.item.phone_number_status" :tags="generateTag(buildStatus(data.item.phone_number_status))" :size="'md'"></ColorTags>
                      </template>
                      <template v-slot:cell(pickup_date)="data">
                        <span>{{data.item.pickup_date | format_date}}</span>
                      </template>
                      <template v-slot:cell(client_use_date)="data">
                        <span>{{data.item.client_use_date | format_date}}</span>
                      </template>
                      <template v-slot:cell(lock_provider)="data">
                        <span>{{getLockProviderList(data.item)}}</span>
                      </template>
                      <template v-slot:cell(open_provider)="data">
                        <span>{{getOpenProviderList(data.item)}}</span>
                      </template>
                      <template v-slot:cell(using_provider)="data">
                        <span>{{getUsingProviderList(data.item)}}</span>
                      </template>
                      <template v-slot:cell(pic_id)="data">
                        <span>{{ getTechnicalStaffName(data.item) }}</span>
                      </template>
                      <template v-slot:cell(lock_histories)="data">
                        <LockSummary v-if="data.item.lock_histories.length > 0" :phoneNumberLockHistories="data.item.lock_histories" :phone-number="data.item" />
                      </template>
                      <template v-slot:cell(updated_at)="data">
                        <span>{{ data.item.updated_at | format_date_time }}</span>
                      </template>
                    </b-table>
                  </div>
                  <div slot="footer">
                    <div><strong>Tổng queue số: </strong><label>{{ totalRow }}</label></div>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="page-size-container">
                        <span>Hiển thị</span>
                        <b-form-select
                          id="pageSize"
                          v-model="pageSize"
                          :options="pageSizes"
                          required
                        ></b-form-select>
                        <span>  dòng</span>
                      </div>
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRow"
                        :per-page="pageSize"
                        aria-controls="my-table"
                      ></b-pagination>
                    </div>
                  </div>
                </Box>
              </div>
            </b-tab>
            <b-tab title="Danh sách SĐT đã kiểm tra">
              <PhoneNumberManagementList :trigger-filter="triggerFilter"></PhoneNumberManagementList>
            </b-tab>
            <b-tab title="Cập nhập trạng thái số khóa">
              <ImportPhoneNumberSectionForTech></ImportPhoneNumberSectionForTech>
            </b-tab>
          </b-tabs>
        </div>
      </Box>
    </section>

    <b-modal size='xl' id="phoneNumberDetailChecking" hide-footer title="Kiểm tra số" @hidden="onModalHidden"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <PhoneNumberChecking :phoneNumber="selected" :hide-modal="hideModal"
                             :statusPhoneNumberId="statusPhoneNumberId"></PhoneNumberChecking>
      </div>
    </b-modal>

    <b-modal size='xl' id="bulkUpdateModal" hide-footer title="Cập nhật trạng thái hàng loạt">
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <label>Trạng thái số</label>
        <div class="d-flex">
          <multiselect v-model="bulkUpdateStatusData" :options="moveStatusList" :multiple="false"
                       :close-on-select="true" :limit="1"
                       placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="pull-right mt-3">
          <b-button variant="success" class="w-150px" @click="saveBulkUpdate" :disabled="!isEditable">Lưu</b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Box from '../../../components/Box.vue'
import {
  FEE_TYPE_LIST,
  LOCAL_STORAGE_KEY, LOCK_COUNT_TYPE, MAX_SALE_USER_NUMBER,
  NUMBER_OF_LOCKED_LIST,
  PERMISSION_KEY, PROVIDERS, STATUS_PHONE_NUMBER
} from '../../../common/constant'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect.vue'
import Utils from '../../../common/utils'
import PhoneNumberChecking from './PhoneNumberChecking.vue'
import LegalAPI from '../../../api/legalApi'
import MainPhoneNumberAPI from '../../../api/mainPhoneNumber'
import PhoneNumberAPI from '../../../api/phoneNumberApi'
import PhoneNumberClientAPI from '../../../api/phoneNumberClientApi'
import PhoneNumberProviderAPI from '../../../api/providerApi'
import PhoneNumberStatusAPI from '../../../api/phoneNumberStatusApi'
import ColorTags from '../../../components/ColorTags.vue'
import ImportPhoneNumberSectionForTech from './ImportPhoneNumberSectionForTech'
import PhoneNumberManagementList from './PhoneNumberCheckedList'
import UserApi from '../../../api/user'
import LockSummary from '../LockSummary.vue'
import {mapGetters} from 'vuex'
// import moment from 'moment'
import Socket from '../../../api/socket'
import moment from 'moment/moment'

export default {
  name: 'PhoneNumberCheckingQueue',
  components: {
    Box,
    DatePicker,
    Multiselect,
    PhoneNumberChecking,
    ColorTags,
    LockSummary,
    ImportPhoneNumberSectionForTech,
    PhoneNumberManagementList
  },
  data () {
    return {
      triggerFilter: false,
      filterData: {
        pickup_date: null,
        locked_date: null,
        cancel_date: null,
        has_fee_date: null,
        phone_number: '',
        main_phone_number: '',
        phone_status: null,
        phone_number_avg_age: 0,
        number_of_locked: NUMBER_OF_LOCKED_LIST[0],
        lock_count_type: [],
        fee_type: null,
        provider: null,
        customer: null,
        legal: null,
        pics: [],
        open_telcos: [],
        using_telcos: [],
        lock_telcos: [],
        viettel_using_status: null,
        mobifone_using_status: null,
        vinaphone_using_status: null,
        other_using_status: null
      },
      usingStatusList: [
        {text: 'Mạng mở', value: 'OPEN'},
        {text: 'Mạng bị khóa', value: 'LOCK'},
        {text: 'Mạng đang sử dụng', value: 'USING'}
      ],
      telcoList: PROVIDERS,
      lock_count_type_list: LOCK_COUNT_TYPE,
      number_of_locked_list: NUMBER_OF_LOCKED_LIST,
      fee_type_list: FEE_TYPE_LIST,
      lockHistories: {},
      statusPhoneNumberId: {
        LOCKED: 0,
        MONITORING: 0,
        FALSE_POSITIVE: 0,
        NEW: 0,
        QUALIFIED: 0,
        UNQUALIFIED: 0,
        RETEST: 0,
        UNLOCKED: 0,
        WAIT_CANCEL: 0,
        NOT_USE: 0
      },
      showConfigSearch: false,
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      configSearchItems: [
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số thành viên',
          show: true
        },
        {
          key: 'phone_status',
          label: 'Trạng thái số',
          show: true
        }
      ],
      configItems: [
        {
          key: 'id',
          label: 'STT',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
          show: true
        },
        {
          key: 'provider',
          label: 'Nhà cung cấp',
          show: true
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
          show: true
        },
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'client_use_date',
          label: 'Ngày khách lấy',
          show: true
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
          show: true
        },
        {
          key: 'brand',
          label: 'Brand',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
          show: true
        },
        {
          key: 'lock_provider',
          label: 'Mạng bị khoá',
          show: true
        },
        {
          key: 'open_provider',
          label: 'Mạng mở',
          show: true
        },
        {
          key: 'using_provider',
          label: 'Mạng đang sử dụng',
          show: true
        },
        {
          key: 'lock_histories',
          label: 'Lịch sử khoá số',
          show: false,
          tdClass: 'padding-0'
        },
        {
          key: 'age',
          label: 'Tuổi thọ của số',
          show: true
        },
        {
          key: 'cancel_date',
          label: 'Ngày huỷ',
          show: true
        },
        {
          key: 'provider_cancel_date',
          label: 'Ngày báo NCC huỷ',
          show: true
        },
        {
          key: 'pic_id',
          label: 'Nhân viên kĩ thuật',
          show: true
        },
        {
          key: 'updated_at',
          label: 'Thời gian cập nhập',
          show: true
        }
      ],
      originFields: [
        {
          key: 'row_selected',
          label: 'Chọn',
          thClass: 'text-center',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
          show: true
        },
        {
          key: 'provider',
          label: 'NCC',
          show: true
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
          show: true
        },
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
          show: true
        },
        {
          key: 'client_use_date',
          label: 'Ngày khách lấy',
          show: true
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
          show: true
        },
        {
          key: 'brand',
          label: 'Brand',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
          show: true
        },
        {
          key: 'lock_provider',
          label: 'Mạng bị khoá',
          show: true
        },
        {
          key: 'open_provider',
          label: 'Mạng mở',
          show: true
        },
        {
          key: 'using_provider',
          label: 'Mạng đang sử dụng',
          show: true
        },
        {
          key: 'lock_histories',
          label: 'Lịch sử khoá số',
          show: false,
          tdClass: 'padding-0'
        },
        {
          key: 'age',
          label: 'Tuổi thọ của số',
          show: true
        },
        {
          key: 'cancel_date',
          label: 'Ngày huỷ',
          show: true
        },
        {
          key: 'provider_cancel_date',
          label: 'Ngày báo NCC huỷ',
          show: true
        },
        {
          key: 'pic_id',
          label: 'Nhân viên kĩ thuật',
          show: true
        },
        {
          key: 'updated_at',
          label: 'Thời gian cập nhập',
          show: true
        }
      ],
      showConfigTable: false,
      fields: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      sumValue: 0,
      pageSizes: [
        {text: 1000, value: 1000},
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      checkingItems: [],
      checkedItems: [],
      activeItems: [],
      phone_number_checking: [],
      selectedId: null,
      selected: null,
      checkingNumber: false,
      multipleSelected: [],
      connected: false,
      retry: 0,
      isEditable: true,
      company: null,
      isTechnicalStaff: false,
      providersList: [],
      phoneStatusList: [],
      moveStatusList: [],
      technicalStatusList: [],
      phoneClientsList: [],
      mainPhoneNumberList: [],
      legalList: [],
      bulkUpdateStatusData: null,
      importFile: null,
      isBulkUpdateAll: false,
      users: [],
      groupUser: [],
      loadingUser: false,
      numberOfUser: 2,
      statistic: {
        age_avg: 0,
        total_init_fee: 0,
        total_operate_fee: 0,
        total_open_fee: 0,
        total_other_fee: 0,
        technical_staff: []
      },
      checkAll: false,
      pingInterval: null,
    }
  },
  onResizeScreen () {
    if (window.innerWidth < 1550) {
      this.numberOfUser = 1
    } else {
      this.numberOfUser = 2
    }
  },
  created () {
    this.fields = this.originFields.filter(item => item.show)
    window.addEventListener('resize', this.onResizeScreen)
  },
  async mounted () {
    // this.isEditable = this.hasEditPermission()
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.isTechnicalStaff = Utils.isTechnicalStaff(this.userInfo)
    await this.initFilter()
    this.initStatusId()
    this.filter()
    this.filterUser('')
    this.startCheckingPhoneNumber(true)

    const phoneNumberSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEM_TECH)
    if (phoneNumberSearchItems) {
      this.configSearchItems = JSON.parse(phoneNumberSearchItems)
    }
    const columnShow = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_COLUMN_SHOW_TECH)
    if (columnShow) {
      this.configItems = JSON.parse(columnShow)

      this.originFields = this.originFields.map(field => {
        let config = this.configItems.find(item => item.key === field.key)
        if (config) {
          return {...field, show: config.show}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)
    }
  },
  methods: {
    onRowSelected (items) {
      this.selected = items
    },
    onDoubleClicked (item) {
      if (item._rowVariant === 'danger') {
        this.$bvModal.msgBoxConfirm(this.showPic(item), {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
        })
      } else {
        this.selected = item
        this.checkingNumber = true
        this.detail(item.id)
        if (this.connected) {
          this.ws.send(JSON.stringify({
            'type': 'take_number',
            'data': {
              'user_id': this.currentUser.user_info.id,
              'phone_number': item.phone_number,
              'phone_number_id': item.id
            }
          }))
        }
      }
    },
    hideModal (modalId) {
      this.$bvModal.hide(modalId)
    },
    onModalHidden () {
      if (this.connected) {
        this.ws.send(JSON.stringify({
          'type': 'release_number',
          'data': {
            'user_id': this.currentUser.user_info.id,
            'phone_number': this.selected.phone_number,
            'phone_number_id': this.selected.id
          }
        }))
      }
      this.$refs.selectableTable.clearSelected()
      this.selected = null
      this.checkingNumber = false
      this.filter()
    },
    showPic (item) {
      if (item.pic) {
        return 'Kỹ thuật viên ' + item.pic + ' đang thao tác'
      }
      return ''
    },
    detail (id) {
      this.selectedId = id
      this.$bvModal.show('phoneNumberDetailChecking')
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEM_TECH, JSON.stringify(this.configSearchItems))
    },
    getFilterRequest () {
      return {
        phone_number: this.filterData.phone_number,
        pickup_date_from: this.filterData.pickup_date ? this.filterData.pickup_date[0] : null,
        pickup_date_to: this.filterData.pickup_date ? this.filterData.pickup_date[1] : null,
        phone_number_status_id_list: this.filterData.phone_status ? this.filterData.phone_status.map(item => item.value) : [],
      }
    },
    onClickPhoneNumber (item) {
      navigator.clipboard.writeText(item)
    },
    copyAllPhoneNumber () {
      if (this.selected === null || this.selected.length === 0) {
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Bạn chưa chọn số')
        return
      }

      navigator.clipboard.writeText(this.selected.map(item => item.phone_number).join('\r\n'))
    },
    filter () {
      if (this.loading) {
        return
      }

      const filter = this.getFilterRequest()
      if (filter.phone_number_status_id_list.length === 0) {
        filter.phone_number_status_id_list = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.NEW, this.statusPhoneNumberId.RETEST, this.statusPhoneNumberId.WAIT_CANCEL, this.statusPhoneNumberId.NOT_USE]
      }

      this.selectedId = null
      this.loading = true
      PhoneNumberAPI.filter(filter, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.checkingItems = res.data.data.records
        this.totalRow = res.data.data.total
        this.sumValue = res.data.data.sum_value
        this.checkingItems.forEach(item => {
          let age
          if (!item.active_date) {
            age = 0
          } else {
            let lastDate = item.cancel_date ? item.cancel_date : new Date()
            age = moment(lastDate).diff(item.active_date, 'days') + 1
          }
          item.age = age
        })
        PhoneNumberAPI.getStatisticPhoneNumber(filter, this.currentPage - 1, this.pageSize).then(
          res => {
            this.statistic = res.data.data
          }
        ).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })

        this.fillPhoneNumberCheckingInfo()
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findTechnicalStaffByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.users.unshift({
          'name': 'Chưa gán kĩ thuật',
          'code': null
        })

        this.filterData.pics = this.users

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.loadingUser = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    search () {
      this.filter()
    },
    exportPhoneNumber () {
      if (this.loading) {
        return
      }
      this.loading = true
      let filter = this.getFilterRequest()
      if (filter.phone_number_status_id_list.length === 0) {
        filter.phone_number_status_id_list = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.NEW, this.statusPhoneNumberId.RETEST, this.statusPhoneNumberId.WAIT_CANCEL, this.statusPhoneNumberId.NOT_USE]
      }

      PhoneNumberAPI.export(filter).then(res => {
        this.loading = false
        let filename = res.data.data.file
        window.location.href = 'https://crm.ity.vn' + filename
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    bulkUpdateStatus () {
      this.isBulkUpdateAll = true
      this.$bvModal.show('bulkUpdateModal')
    },
    bulkUpdateSelectedStatus () {
      if (this.selected === null || this.selected.length === 0) {
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Bạn chưa chọn số')
        return
      }

      this.isBulkUpdateAll = false
      this.$bvModal.show('bulkUpdateModal')
    },
    addPhoneNumber () {
      this.selectedId = null
      this.$bvModal.show('phoneNumberDetailChecking')
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    toggleColumn (event, key) {
      this.originFields = this.originFields.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)

      this.configItems = this.configItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_COLUMN_SHOW_TECH, JSON.stringify(this.configItems))
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER)
    },
    async getLegal () {
      const response = await LegalAPI.filter({}, 0, 500)
      return response.data.data.records
    },
    async getMainPhoneNumber () {
      const response = await MainPhoneNumberAPI.filter({}, 0, 500)
      return response.data.data.records
    },
    async getPhoneNumberClient () {
      const response = await PhoneNumberClientAPI.filter({}, 0, 500)
      return response.data.data.records
    },
    async getPhoneNumberStatus () {
      const response = await PhoneNumberStatusAPI.filter({}, 0, 500)
      return response.data.data.records
    },
    async getPhoneNumberProvider () {
      const response = await PhoneNumberProviderAPI.filter({}, 0, 500)
      return response.data.data.records
    },
    async initFilter () {
      return Promise.all([this.getLegal(), this.getMainPhoneNumber(), this.getPhoneNumberClient(),
        this.getPhoneNumberStatus(), this.getPhoneNumberProvider()])
        .then(([legals, mainPhoneNumbers, phoneClients, status, providers]) => {
          this.legalList = legals.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.LEGAL_LIST, JSON.stringify(this.legalList))
          this.mainPhoneNumberList = mainPhoneNumbers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.MAIN_PHONE_NUMBER_LIST, JSON.stringify(this.mainPhoneNumberList))
          this.phoneClientsList = phoneClients.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_CLIENT, JSON.stringify(this.phoneClientsList))
          this.phoneStatusList = status.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_STATUS_LIST, JSON.stringify(this.phoneStatusList))
          this.providersList = providers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PROVIDER_LIST, JSON.stringify(this.providersList))
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
    },
    buildPhoneClient (value) {
      return this.phoneClientsList.find(item => item.value === value)
    },
    buildStatus (value) {
      return this.phoneStatusList.find(item => item.value === value)
    },
    buildLegal (value) {
      return this.legalList.find(item => item.value === value)
    },
    buildProvider (value) {
      return this.providersList.find(item => item.value === value)
    },
    generateTag (selectedRow) {
      if (selectedRow) {
        const text = selectedRow.text
        const color = selectedRow.color
        return [{text: text, color: color}]
      }
    },
    buildMainPhoneNumber (value) {
      return this.mainPhoneNumberList.find(item => item.value === value)
    },
    saveBulkUpdate () {
      if (this.loading) {
        return
      }
      this.loading = true
      if (this.isBulkUpdateAll) {
        let filter = this.getFilterRequest()
        if (filter.phone_number_status_id_list.length === 0) {
          filter.phone_number_status_id_list = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.NEW, this.statusPhoneNumberId.RETEST, this.statusPhoneNumberId.WAIT_CANCEL, this.statusPhoneNumberId.NOT_USE]
        }
        PhoneNumberAPI.bulkUpdateStatusForTech(filter, this.bulkUpdateStatusData ? this.bulkUpdateStatusData.value : 0).then(res => {
          this.loading = false
          this.$bvModal.hide('bulkUpdateModal')
          Utils.successToast(this.$bvToast)
          this.filter()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        const idList = this.selected.map(item => item.id)
        PhoneNumberAPI.updateListPhoneNumberStatusForTech(idList, this.bulkUpdateStatusData ? this.bulkUpdateStatusData.value : 0).then(res => {
          this.loading = false
          this.$bvModal.hide('bulkUpdateModal')
          Utils.successToast(this.$bvToast)
          this.filter()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    getTechnicalStaffStatistic () {
      const staffList = this.statistic.technical_staff.map(staff => `${staff.user}(${staff.count})`)
      return staffList.join(', ')
    },
    getTechnicalStaffName (item) {
      if (item.pic_id) {
        const found = this.users.find(u => u.code === item.pic_id)
        if (found !== undefined) {
          return found.name
        }
      }
      return ''
    },
    getLockProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'LOCK') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'LOCK') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'LOCK') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'LOCK') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    getOpenProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'OPEN') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'OPEN') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'OPEN') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'OPEN') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    getUsingProviderList (item) {
      try {
        let res = []
        if (item.viettel_using_status === 'USING') {
          res.push('Viettel')
        }
        if (item.mobifone_using_status === 'USING') {
          res.push('Mobifone')
        }
        if (item.vinaphone_using_status === 'USING') {
          res.push('Vinaphone')
        }
        if (item.other_using_status === 'USING') {
          res.push('Ngoại mạng')
        }

        return res.join(', ')
      } catch (e) {
        return ''
      }
    },
    onCheckAll (event) {
      if (this.checkAll === 'check_all') {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    toggleRow (row) {
      if (row.rowSelected) {
        this.$refs.selectableTable.selectRow(row.index)
      } else {
        this.$refs.selectableTable.unselectRow(row.index)
      }
    },
    startCheckingPhoneNumber (retryable) {
      this.ws = Socket.getSocket()
      this.ws.onopen = () => {
        console.log('WS Connected')
        this.connected = true
        this.retry = 0
        this.pingInterval = setInterval(() => {
          this.ws.send(JSON.stringify({
            'type': 'ping',
            'data': ''
          }))
        }, 0.5 * 60 * 1000)
        this.filter()
      }
      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data)
        if (data.type === 'update_phone_number_queue') {
          if (!this.checkingNumber) {
            this.filter()
          }
          this.triggerFilter = !this.triggerFilter
        }
        if (data.type === 'update_phone_number') {
          this.phone_number_checking = data.data
          this.fillPhoneNumberCheckingInfo()
        }
      }
      this.ws.ondisconnect = (event) => {
        console.log('WS ondisconnect')
        this.connected = false
        this.loading = false
        this.processRetry(retryable)
      }
      this.ws.onclose = (event) => {
        console.log('WS onclose')
        this.connected = false
        this.loading = false
        if (event.wasClean) {
          console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`)
        }
        this.processRetry(retryable)
      }
      this.ws.onerror = (error) => {
        this.connected = false
        this.loading = false
        console.error('WebSocket error:', error)
        this.processRetry(retryable)
      }
      this.startIntervalCheck()
    },
    startIntervalCheck () {
      this.interval = setInterval(() => {
        console.log('Interval check ws connection...')
        if (this.ws.readyState !== WebSocket.OPEN) {
          console.log('WebSocket is not open, reconnecting...')
          this.startCheckingPhoneNumber(false)
        }
      }, 15000)
    },
    processRetry (retryable) {
      if (retryable) {
        if (this.retry <= 3) {
          setTimeout(() => {
            console.log('Start retry = ' + this.retry)
            this.startCheckingPhoneNumber(false)
            this.retry++
          }, 5000)
        }
      }
    },
    fillPhoneNumberCheckingInfo () {
      this.checkingItems = this.checkingItems.map(item => {
        const phoneNumber = this.phone_number_checking.find(p => p.phone_number === item.phone_number)

        if (phoneNumber && phoneNumber.user === this.currentUser.user_info.username) {
          item._rowVariant = 'info'
          item.pic = phoneNumber.user
        } else {
          item._rowVariant = null
          item.pic = null
        }

        if (phoneNumber && phoneNumber.user !== this.currentUser.user_info.username) {
          item._rowVariant = 'danger'
          item.pic = phoneNumber.user
        } else {
          item._rowVariant = null
          item.pic = null
        }
        return item
      })
    },
    initStatusId () {
      let id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.LOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.LOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.MONITORING)
      if (id !== undefined) {
        this.statusPhoneNumberId.MONITORING = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.FALSE_POSITIVE)
      if (id !== undefined) {
        this.statusPhoneNumberId.FALSE_POSITIVE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NEW)
      if (id !== undefined) {
        this.statusPhoneNumberId.NEW = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.QUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.QUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNQUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNQUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.RETEST)
      if (id !== undefined) {
        this.statusPhoneNumberId.RETEST = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNLOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNLOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.WAIT_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.WAIT_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.NOT_USE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_NOT_USE = id.value
      }

      let allowStatusList = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.NEW, this.statusPhoneNumberId.RETEST, this.statusPhoneNumberId.WAIT_CANCEL, this.statusPhoneNumberId.NOT_USE]
      this.technicalStatusList = this.phoneStatusList.filter(item => allowStatusList.indexOf(item.value) > -1)

      allowStatusList = [this.statusPhoneNumberId.CONFIRM_CANCEL, this.statusPhoneNumberId.CONFIRM_NOT_USE, this.statusPhoneNumberId.LOCKED, this.statusPhoneNumberId.FALSE_POSITIVE, this.statusPhoneNumberId.QUALIFIED, this.statusPhoneNumberId.UNQUALIFIED, this.statusPhoneNumberId.UNLOCKED]
      this.moveStatusList = this.phoneStatusList.filter(item => allowStatusList.indexOf(item.value) > -1)
    },
    handleTabChange () {
      this.filter()
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'currentUser'
    ])
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/techical_list/PhoneNumberForTechList.vue